import script from "./TicketPresentationView.vue?vue&type=script&lang=ts&setup=true"
export * from "./TicketPresentationView.vue?vue&type=script&lang=ts&setup=true"

import "./TicketPresentationView.vue?vue&type=style&index=0&id=0b4f5c98&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b4f5c98"]])

export default __exports__